import React, { useState, useEffect } from 'react';
import { getTestimonials } from '../services/api';
import { Card, CardContent } from './ui/card';
import { Star } from 'lucide-react';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getTestimonials();
        setTestimonials(data);
      } catch (error) {
        console.error('Error fetching testimonials:', error);
      }
    };
    fetchData();
  }, []);

  return (
    <section className="py-24 px-4" style={{ backgroundColor: '#FFCCE0' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2
            className="md:text-6xl !font-bold !text-5xl mb-4"
            style={{ fontFamily: "'Crimson Text', serif" }}>Lo que dicen nuestros comensales


          </h2>
          <p className="max-w-2xl !text-lg mx-auto text-gray-700">Echa un vistazo a las opiniones de nuestros valiosos clientes sobre sus experiencias.

          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {testimonials.map((testimonial) =>
          <Card
            key={testimonial.id}
            className="bg-white/80 backdrop-blur-sm hover:shadow-lg transition-shadow duration-200">

              <CardContent className="p-6">
                <div className="flex mb-3">
                  {[...Array(testimonial.rating)].map((_, i) =>
                <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                )}
                </div>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  "{testimonial.comment}"
                </p>
                <div className="flex justify-between items-center">
                  <p className="font-semibold">{testimonial.name}</p>
                  <p className="text-sm text-gray-500">
                    {new Date(testimonial.date).toLocaleDateString('es-MX', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                  </p>
                </div>
              </CardContent>
            </Card>
          )}
        </div>
      </div>
    </section>);

};

export default Testimonials;